module.exports = __webpack_public_path__ + "img/lib_region_flag_sx.ebab09ed.png";